import { CloseOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { Modal, Input, Table, Button, Select } from 'antd'
import moment from 'moment'
import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import ErrorModal from '@Modal/ErrorModal'
import SuccessModal from '@Modal/SuccessModal'
import { http } from '@services/http'
import {
	fetchPurchasesIncoming,
	fetchLandedCostsByPurchaseInvoice,
 fetchCostTypes } from '@utils/fetchData'
import {
	numberWithSpacesIntl,
	formatNumberWithSpaces,
} from '@utils/numberWithSpaces'

import CreteLandedCostsModal from '../createLandedCostsModal'
import InvoiceVendorPaymentModal from '../invoiceVendorPaymentModal'



const ViewPurchasesModal = ({
	data,
	finishSale = false,
	ship = false,
	changeStatus = false,
	showPayment = false,
	refetch,
	onClose,
	isShowLandedCosts = false,
	isShowPriceAtWhs = false,
	isShowDocRate = false,
}) => {
	const { t } = useTranslation()

	const successRef = useRef()
	const errorRef = useRef()

	const roleNames = useSelector((state) => state.main.roleNames)
	const employeeId = useSelector((state) => state.main.employeeId)
	const salesPersonCode = useSelector((state) => state.main.salesPersonCode)
	const { getMe } = useSelector((state) => state.main)
	console.log('getMe', getMe)
	console.log('roleNames', roleNames)

	const [dueDate, setDueDate] = useState('')
	const [shipBtnLoading, setShipBtnLoading] = useState(false)
	const [status, setStatus] = useState('')
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [dopZatrataModal, setDopZatrataModal] = useState(false)
	const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false)
	const [tableData, setTableData] = useState([])
	const [furaNum, setFuraNum] = useState('')
	const [invoiceNum, setInvoiceNum] = useState('')

	const payBtnDisabled =
		data?.docCurrency === 'UZS' && data.docTotal <= data.paidToDate
			? true
			: data?.docCurrency === 'USD' && data.docTotal <= data.paidToDateFC
				? true
				: false

	const {
		data: purchaseIncomingData = [],
		isLoading: loadingPurchaseIncoming,
		refetch: loadingPurchaseIncomingRefetch,
	} = useQuery({
		queryKey: ['purchaseIncoming', data?.docEntry],
		queryFn: fetchPurchasesIncoming,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
	})

	const {
		data: landedCostsData = [],
		isLoading: loadingLandedCosts,
		refetch: refetchLandedCosts,
	} = useQuery({
		queryKey: ['landedCosts', data?.docEntry],
		queryFn: fetchLandedCostsByPurchaseInvoice,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
		enabled: !!data?.docEntry,
	})

	const handleQuantityChange = (value, index) => {
		const updatedData = [...tableData]
		console.log('Value: ' + value)
		updatedData[index].openQty = value
		setTableData(updatedData)
	}

	useEffect(() => {
		if (data?.docDate) {
			setDueDate(data?.docDate)
		}
		if (data?.u_Status) {
			setStatus(data.u_Status)
		}
		if (data?.documentLines) {
			setTableData(
				data.documentLines.map((item, index) => ({
					...item,
					key: index,
					itemDescription: item.itemDescription,
					quantity: item.quantity,
					price: item.price,
					lineTotal: item.lineTotal,
					whsName: item.whsName,
					ugpCode: item.ugpCode,
					lineNum: item.lineNum,
					warehouseCode: item.warehouseCode,
					currency: item.currency,
					itemCode: item.itemCode,
					kvmetr: item.kvmetr,
					openQty: parseFloat(
						item.openQty / (item.itemKvMetr || 1),
					).toFixed(2),
					existedQuantity: item.openQty,
					openQtyInQuantity: item.openQty / item.itemKvMetr,
					itemKvMetr: item.itemKvMetr,
				})),
			)
		}
		if (data?.u_FuraNum) {
			setFuraNum(data.u_FuraNum)
		}
		if (data?.u_InvoiceNum) {
			setInvoiceNum(data.u_InvoiceNum)
		}
	}, [data])

	const finishSalePost = async () => {
		setShipBtnLoading(true)

		const documentLines = purchaseIncomingData
			.map((line) => line.documentLines)
			.flat()
			.map((item, idx) => {
				return {
					baseEntry: item.docEntry,
					baseLine: item.lineNum,
					itemCode: item.itemCode,
					quantity: item.quantity,
					price: item.price,
					currency: item.currency,
					warehouseCode: item.warehouseCode,
					u_Kvmetr: (item.quantity / item.kvmetr).toFixed(2),
				}
			})

		const postingData = {
			cardCode: purchaseIncomingData[0]?.cardCode,
			documentsOwner: employeeId,
			salesPersonCode: salesPersonCode,
			docDueDate: moment(dueDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
			docDate: moment(dueDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
			comments: purchaseIncomingData[0]?.comments,
			docCurrency: purchaseIncomingData[0]?.docCurrency,
			u_FuraNum: purchaseIncomingData[0]?.u_FuraNum,
			u_InvoiceNum: purchaseIncomingData[0]?.docNum,
			documentLines,
		}

		try {
			await http.post(
				`api/purchase/haridni-yakunlash/${data?.docEntry}`,
				postingData,
			)
			onClose()
			refetch()
			successRef.current?.open(t('sucCreation'))
		} catch (error) {
			console.log(error)
			errorRef.current?.open(error?.response?.data?.message)
		} finally {
			setShipBtnLoading(false)
		}
	}

	const shipData = async () => {
		setShipBtnLoading(true)

		console.log(tableData)
		const documentLines = tableData
			.filter(
				(item) => Number(item.openQty * item.itemKvMetr).toFixed(2) > 0,
			)
			.map((item, idx) => {
				return {
					baseEntry: data.docEntry,
					baseLine: item.lineNum,
					itemCode: item.itemCode,
					quantity: item.openQty * item.itemKvMetr,
					price: item.price,
					currency: item.currency,
					warehouseCode: item.warehouseCode,
					u_Kvmetr: item.openQty,
				}
			})

		const postingData = {
			cardCode: data?.cardCode,
			docDueDate: moment(data?.docDueDate, 'DD.MM.YYYY').format(
				'YYYY-MM-DD',
			),
			docDate: moment(data?.docDate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
			documentsOwner: employeeId,
			salesPersonCode: salesPersonCode,
			docCurrency: data.docCurrency,
			comments: data?.comments || '',
			u_FuraNum: furaNum,
			u_InvoiceNum: invoiceNum,
			documentLines,
		}

		try {
			await http.post(
				'api/purchase/yetib-kelgan-buyurtmalar',
				postingData,
			)
			onClose()
			refetch()
			successRef.current?.open(t('sucCreated'))
		} catch (error) {
			errorRef.current?.open(error?.response?.data?.message)
		} finally {
			setShipBtnLoading(false)
		}
	}
	const patchStatus = async () => {
		setShipBtnLoading(true)

		try {
			await http.patch(
				'api/purchase/xarid-uchun-buyurtma/update-status',
				{
					docNum: data.docNum,
					docEntry: data.docEntry,
					u_Status: status,
					u_FuraNum: furaNum,
					u_InvoiceNum: invoiceNum,
				},
			)
			successRef.current?.open(t('sucChangeStatus'))
			onClose()
		} catch (error) {
			errorRef.current?.open(error?.response?.data?.message)
		} finally {
			setShipBtnLoading(false)
		}
	}

	if (!data) return null

	const columns = [
		{
			title: t('item'),
			dataIndex: 'itemDescription',
			key: 'itemDescription',
			width: 150,
			render: (text, record, index) => {
				return <span>{text}</span>
			},
		},

		{
			title: t('quantityInBegin'),
			dataIndex: 'kvmetr',
			key: 'kvmetr',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return <span> {formattedText}</span>
			},
		},
		{
			title: t('openQty'),
			dataIndex: 'openQty',
			key: 'openQty',
			render: (text, record, index) =>
				ship && data.u_Status === 'Arrived' ? (
					<Input
						type="number"
						value={record.openQty}
						onChange={(e) =>
							handleQuantityChange(e.target.value, index)
						}
						onWheel={(e) => e.target.blur()}
					/>
				) : (
					<span> {formatNumberWithSpaces(text)}</span>
				),
		},
		{
			title: t('boxCount'),
			dataIndex: 'u_Box',
			key: 'u_Box',
		},
		{
			title: t('kv.m'),
			dataIndex: 'quantity',
			key: 'quantity',
		},

		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {data.docCurrency}
					</span>
				)
			},
		},

		{
			title: t('totalMiqdor'),
			dataIndex: 'lineTotal',
			key: 'lineTotal',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {record?.currency}
					</span>
				)
			},
		},
		{
			title: t('whs'),
			dataIndex: 'whsName',
			key: 'whsName',
		},
	]

	// if (isShowPriceAtWhs) {
	// 	columns.splice(6, 0, {
	// 		title: t('priceAtWh'),
	// 		dataIndex: 'priceAtWh',
	// 		key: 'priceAtWh',
	// 		render: (text, record, index) => {
	// 			const formattedText = new Intl.NumberFormat('fr-FR').format(
	// 				text,
	// 			)
	// 			return (
	// 				<span>
	// 					{formattedText} {record?.priceAtWhCurrency}
	// 				</span>
	// 			)
	// 		},
	// 	})
	// }

	return (
		<div className="w-full px-5">
			<div className="w-full">
				<div className="mt-10 flex flex-col gap-5 items-center  sm:flex-row flex-wrap">
					<div className="flex flex-col gap-3">
						<p className="font-bold">{t('mijoz')}</p>
						<Input
							type="text"
							value={data.cardName}
							className="flex  w-[200px] items-center justify-center sm:w-[250px]"
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					{changeStatus ? (
						<div className="flex flex-col gap-3">
							<p className="font-bold">{t('status')}</p>
							<Select
								type="text"
								value={t(`${status}`)}
								className="flex  w-[200px] items-center justify-center sm:w-[250px]"
								style={{ color: 'black' }}
								onChange={(val) => {
									setStatus(val)
								}}
								disabled={getMe.jobTitle === 'Wrhmanager'}
							>
								<Select.Option value={'Not Arrived'}>
									{t('NotArrived')}
								</Select.Option>
								<Select.Option value={'Arrived'}>
									{t('Arrived')}
								</Select.Option>
							</Select>
						</div>
					) : (
						<div className="flex flex-col gap-3">
							<p className="font-bold">{t('status')}</p>
							<Input
								value={t(`${status}`)}
								style={{ color: 'black' }}
								className="flex  w-[200px] items-center justify-center sm:w-[250px]"
								disabled
							/>
						</div>
					)}

					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('currency')}</p>
						<Input
							value={data.docCurrency}
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('invoiceNum')}</p>
						<Input
							value={invoiceNum}
							onChange={(e) => setInvoiceNum(e.target.value)}
							className="min-w-[150px]"
							type="text"
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('furaNum')}</p>
						<Input
							value={furaNum}
							onChange={(e) => setFuraNum(e.target.value)}
							className="min-w-[150px]"
							type="text"
							style={{ color: 'black' }}
							disabled={!changeStatus}
						/>
					</div>
					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('date')}</p>
						<Input
							type="text"
							value={dueDate}
							style={{ color: 'black' }}
							onChange={(e) => {
								console.log(e.target.value)
								setDueDate(e.target.value)
							}}
							disabled
							// disabled={
							// 	finishSale && roleNames.includes('Supplier')
							// 		? false
							// 		: true
							// }
						/>
					</div>
					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('debtDoc')}</p>
						<Input
							type="text"
							value={`${numberWithSpacesIntl(data?.docCurrency === 'UZS' ? data?.docTotal - data?.paidToDateFC : data?.docTotal - data?.paidToDate)} ${data?.docCurrency}`}
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					{isShowDocRate && (
						<div className="mt-4 flex flex-col gap-3 sm:mt-0">
							<p className="font-bold">{t('docRate')}</p>
							<Input
								type="text"
								value={formatNumberWithSpaces(data?.docRate)}
								style={{ color: 'black' }}
								disabled
							/>
						</div>
					)}
				</div>
				<Table
					columns={columns}
					dataSource={tableData}
					pagination={false}
					className="border-1 mt-12 border-black"
					scroll={{ x: '100%' }}
					bordered
				/>

				<div className="w-full flex items-center justify-between mt-20  ">
					<div className="flex flex-col items-start gap-3 ">
						<p className="font-bold">{t('totalForDocument')}</p>
						<Input
							type="text"
							value={`${new Intl.NumberFormat('fr-FR').format(data.docTotal)} ${data.docCurrency}`}
							className="flex h-8 w-[70px] items-center justify-center sm:w-[250px]"
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					<div className="flex flex-col items-start gap-3 ">
						<p className="font-bold">{t('comments')}</p>
						<Input.TextArea
							type="text"
							value={data?.comments}
							className="flex h-8 w-[70px] items-center justify-center sm:w-[350px]"
							style={{ color: 'black' }}
							disabled
						/>
					</div>
				</div>
				<div className="w-full flex items-center justify-end mt-10  ">
					<>
						{' '}
						{ship && data.u_Status === 'Arrived' ? (
							<Button
								onClick={shipData}
								loading={shipBtnLoading}
								className="h-[30px] w-auto  bg-[#0A4D68] rounded-lg text-white "
							>
								{t('ship')}
							</Button>
						) : (
							''
						)}
						{changeStatus ? (
							<Button
								onClick={patchStatus}
								loading={shipBtnLoading}
								className="h-[30px] w-auto bg-[#0A4D68] rounded-lg text-white "
							>
								{t('changeStatus')}
							</Button>
						) : (
							''
						)}
						<div className="flex gap-5">
							{showPayment ? (
								<Button
									onClick={() => {
										setIsPaymentModalVisible(true)
									}}
									// loading={shipBtnLoading}
									className="h-[30px] bg-[#0A4D68] rounded-lg text-white"
									disabled={payBtnDisabled}
								>
									{t('pay')}
								</Button>
							) : (
								''
							)}
							{/* {isShowLandedCosts && (
								<Button
									onClick={() => {
										setDopZatrataModal(true)
										console.log('Button Clicked')
									}}
									loading={
										shipBtnLoading || loadingLandedCosts
									}
									disabled={landedCostsData.length > 0}
									className="h-[30px] bg-[#0A4D68] rounded-lg text-white"
								>
									{t('addLandedCosts')}
								</Button>
							)} */}

							{/* {finishSale ? (
								<Button
									onClick={handleButtonClick}
									loading={shipBtnLoading}
									className="h-[30px] bg-[#0A4D68] rounded-lg text-white"
								>
									{t('finishInvoice')}
								</Button>
							) : (
								''
							)} */}
						</div>
					</>
				</div>
			</div>

			<InvoiceVendorPaymentModal
				visible={isPaymentModalVisible}
				onClose={() => setIsPaymentModalVisible(false)}
				data={data}
			/>
			<CreteLandedCostsModal
				visible={dopZatrataModal}
				data={data}
				docDate={moment().format('YYYY-MM-DD')}
				onClose2={() => {
					setDopZatrataModal(false)
					refetchLandedCosts()
				}}
				refetch={() => refetch()}
			/>
			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
		</div>
	)
}

export default ViewPurchasesModal
